import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { BerthCall } from 'src/types/ViewModel/BerthCall';
import { ReportLocationEnum } from 'src/enums/reportLocationEnum';
import { RotationTreeEnum } from 'src/enums/rotationTreeEnum';
import { emptyMoveActionMsg } from './moveActionMsgUtils';
import { PortCall } from 'src/types/ViewModel/PortCall';
import { mapCargoOperationToRotationCargoOperationSimple, mapRotationCargoOperationsToCargoOperations } from './cargoOperationUtils';
import { isManualCall } from '../../stowageRotationUtils';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';

export const mapBerthCallToRotationBerthCallSimple = (portCall: RotationPortCall, berthCall: BerthCall): RotationBerthCall => {
    const rotationBerthCall = {
        berthCallGuid: crypto.randomUUID(),
        imosBerthCallId: berthCall.berthCallId,
        berthId: berthCall.berthId,
        berthName: berthCall.name,
    } as RotationBerthCall;

    rotationBerthCall.portCall = portCall;
    rotationBerthCall.cargoOperations =
        berthCall.cargoOperationArray.map((co) => mapCargoOperationToRotationCargoOperationSimple(rotationBerthCall, co)) ?? [];

    return rotationBerthCall;
};

/**
 * Maps RotationBerthCalls to BerthCalls
 */
export const mapRotationBerthCallsToBerthCalls = (
    rotationBerthCalls: RotationBerthCall[],
    voyageNumberString: string,
    portCall: PortCall
): BerthCall[] => {
    return rotationBerthCalls.map((bc) => mapRotationBerthCallToBerthCall(bc, voyageNumberString, portCall));
};

/**
 * Maps a RotationBerthCall to a BerthCall
 */
const mapRotationBerthCallToBerthCall = (rotationBerthCall: RotationBerthCall, voyageNumberString: string, portCall: PortCall): BerthCall => {
    const berthCall = {
        berthCallId: rotationBerthCall.imosBerthCallId,
        id: rotationBerthCall.imosBerthCallId,
        cargoOperationArray: [],
        berthId: rotationBerthCall.berthId,
        voyageNumber: voyageNumberString,
        name: rotationBerthCall.berthName,
        arrivalDate: null,
        departureDate: null,
        portCall: portCall,
        nodeStatus: '',
        isDeleted: false,
        addedDeletedBerthCall: false,
        isLocked: false,
        isMoved: false,
        isMovedTo: false,
        isSelected: false,
        isExpanded: false,
        movedFromClicked: false,
        deletedIconTooltipText: null,
        moveToBerthCallId: null,
        aolDate: null,
        reportLocation: ReportLocationEnum.Port,
        manualBerthSequenceNumber: null,
        imosPortFunction: null,
        portClusterInitialPortId: null,
        portClusterInitialPortName: null,
        delayInputWarningText: null,
        firstTimeInPortCall: null,
        timezoneWarningText: null,
        type: RotationTreeEnum.BerthCall,
        actionMsg: emptyMoveActionMsg,
    };

    berthCall.cargoOperationArray = mapRotationCargoOperationsToCargoOperations(
        rotationBerthCall.cargoOperations.filter((co) => !isManualCall(co)),
        berthCall
    );
    return berthCall;
};
